import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal({ closeModal }) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>WebP Converter</h1>
			<div className='project-popup__description '>
				WebP Converter is an Electron (React + TS) desktop application designed to
				help users easily convert images to WebP format. The app has a killer feature
				that allows users to drag and drop an entire project folder containing images
				into the dropzone. The app will automatically search all sub-folders
				recursively and convert all images to WebP format. The converted images are
				then placed in the same directory where the specific image was found, making
				the process easy and straightforward.
				<br />
				Users can also set up the required quality for the converted images and see
				how much size was saved.
				<br />
				Additionally, the app has a dark theme feature that takes the current theme
				of the user system. This feature makes it easier for users to use the app in
				their preferred environment without straining their eyes.
				<br />
				The app has been tested for macOS and has been designed to provide a smooth
				and seamless user experience. WebP Converter is an essential tool for web
				developers and designers who need to optimize their images for the web.
			</div>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						Electron, electron-vite, React.js, TypeScript, Ant Design, cwebp
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/z1coiiUgi7Q'
					title='WebP Converter (Electron desktop app)'
				/>
			</div>

			<div className='project-popup__buttons '>
				<a
					href='https://github.com/Slava-Nik/webp-electron-converter'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Source code
				</a>
				<CloseModalButton onClose={closeModal} />
			</div>
		</div>
	);
}
